import { Box, Button, Heading, Icon, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { MdLock } from "react-icons/md";
import { Link } from "react-router";

type IaPaywallProps = {
  textColor?: string;
};

const IaPaywall = ({ textColor = "#fff" }: IaPaywallProps) => {
  const { t } = useTranslation();
  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      flexDir={"column"}
      gap={4}
      color={textColor}
      p={[4, 8]}
    >
      <Icon as={MdLock} boxSize={16} color={textColor} />
      <Heading>{t("summarize.free.title")}</Heading>
      <Text fontSize={"1.5rem"}>{t("summarize.free.subtitle")}</Text>
      <Button as={Link} to={"/pricing"} colorScheme="brand" borderRadius={12}>
        {t("summarize.free.button")}
      </Button>
    </Box>
  );
};

export default IaPaywall;
